import React, { useState, useEffect } from 'react';
import { Box, MenuItem, TextField, Typography } from '@mui/material';
import { searchSummary } from '../common/form/MobileFilterCollapse';
import SearchCard, { fieldProps } from '../common/list/SearchCard';
import 'dayjs/locale/ko';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import * as dayjs from 'dayjs';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';
import MobileAddFab from '../common/search/MobileAddFab';

// 작업지원 요청 관리(/reqtechmng) 검색 영역 - chancemng 설계(fc30533) 적용(2026-10-22).
// add/handleAdd는 호출부가 안 넘기면(현재 reqtechmng 그대로) 아무 버튼도 안 나온다(기존과 동일).
export const TechReqListBox = ({ add, handleAdd, formik, onReset }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    if (formik.values.searchStrtDt) {
      setSearchStrtDt(dayjs(formik.values.searchStrtDt));
    }
    if (formik.values.searchEndDt) {
      setSearchEndDt(dayjs(formik.values.searchEndDt));
    }
  }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <>
      <SearchCard
        summary={searchSummary(formik.values)}
        onSubmit={formik.handleSubmit}
        onReset={onReset}
        submitting={formik.isSubmitting}
        gridSx={{
          gridTemplateAreas: {
            xs: `"keyword" "search" "period" "btns"`,
            sm: `"keyword search" "period btns"`,
          },
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'minmax(160px, 0.8fr) minmax(180px, 1.2fr)',
          },
          '@media (min-width:1440px)': {
            gridTemplateAreas: `"keyword search period btns"`,
            gridTemplateColumns:
              'minmax(160px, 0.7fr) minmax(180px, 1fr) minmax(280px, 1.1fr) 190px',
          },
        }}
      >
        {/* 검색키워드 */}
        <Box sx={{ gridArea: 'keyword', minWidth: 0 }}>
          <TextField
            {...fieldProps}
            select
            fullWidth
            required={false}
            id="searchKeyword"
            name="searchKeyword"
            label="검색키워드"
            value={formik.values.searchKeyword}
            onChange={formik.handleChange}
            error={formik.touched.searchKeyword && Boolean(formik.errors.searchKeyword)}
            helperText={formik.touched.searchKeyword && formik.errors.searchKeyword}
          >
            <MenuItem value="">검색키워드</MenuItem>
            <MenuItem value="reqNo">작업요청번호</MenuItem>
            <MenuItem value="custNm">고객명</MenuItem>
            <MenuItem value="custEmpNm">고객담당자명</MenuItem>
            <MenuItem value="workTyp">작업종류</MenuItem>
          </TextField>
        </Box>

        {/* 검색어 */}
        <Box sx={{ gridArea: 'search', minWidth: 0 }}>
          <TextField
            {...fieldProps}
            fullWidth
            required={false}
            id="searchWords"
            name="searchWords"
            label="검색어"
            value={formik.values.searchWords || ''}
            onChange={formik.handleChange}
            error={formik.touched.searchWords && Boolean(formik.errors.searchWords)}
            helperText={formik.touched.searchWords && formik.errors.searchWords}
            InputProps={{
              endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
            }}
          />
        </Box>

        {/* 등록 시작~종료일 */}
        <Box sx={{ gridArea: 'period', minWidth: 0 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
              <DatePicker
                label="등록 시작일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="searchStrtDt"
                name="searchStrtDt"
                value={searchStrtDt}
                onChange={(newValue) => {
                  setSearchStrtDt(dayjs(newValue));
                  onChangeDate(dayjs(newValue), 'searchStrtDt');
                }}
                slotProps={{
                  textField: {
                    ...fieldProps,
                    sx: { minWidth: 0, flex: '1 1 130px' },
                    error: formik.touched.searchStrtDt && Boolean(formik.errors.searchStrtDt),
                    helperText: formik.touched.searchStrtDt && formik.errors.searchStrtDt,
                  },
                }}
              />
              <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
                ~
              </Typography>
              <DatePicker
                label="등록 종료일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="searchEndDt"
                name="searchEndDt"
                value={searchEndDt}
                onChange={(newValue) => {
                  setSearchEndDt(dayjs(newValue));
                  onChangeDate(dayjs(newValue), 'searchEndDt');
                }}
                slotProps={{
                  textField: {
                    ...fieldProps,
                    sx: { minWidth: 0, flex: '1 1 130px' },
                    error: formik.touched.searchEndDt && Boolean(formik.errors.searchEndDt),
                    helperText: formik.touched.searchEndDt && formik.errors.searchEndDt,
                  },
                }}
              />
            </Box>
          </LocalizationProvider>
        </Box>
      </SearchCard>
      {add && <MobileAddFab onClick={handleAdd} aria-label="신규 지원 작성" />}
    </>
  );
};
